// Styles
import styled, { css } from "styled-components";
import { colors } from "../../../utils";

export const mainStack = styled.div`
  width: 30vw;
  height: 92vh;
  background-color: white;
  overflow-y: auto;
  overflow-x: hidden;
  // z-index: 1000;
  border-radius: 4px;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  padding: 16px 0px 0px 0px;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  ${({ isVisible }) =>
    isVisible &&
    css`
      transform: translateX(1px);
    `}
`;

export const Container = styled.div`
  position: relative;
  height: 90vh;
  padding: 10px;
  background-color: white;
  overflow: hidden;
`;

export const Pane = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  ${({ isVisible }) =>
    isVisible
      ? css`
          transform: translateX(0%);
          opacity: 1;
        `
      : css`
          transform: translateX(-100%);
          opacity: 0;
        `}
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid ${colors.lightBorder};
`;
